import { FormControl } from '@angular/forms';
export class FormUtils {
    public static getErrorMessage(formControl: FormControl): String {
        if (formControl.hasError("required")) {
            return 'Harus diisi';
        }
        return '';
    }
}